const newsCategoriesPath = '/articles/categories';
export const getArticlesCategories = newsCategoriesPath;
export const getArticleCategoryById = (id: number) => `${newsCategoriesPath}/${id}?`;
export const createArticleCategory = `${newsCategoriesPath}`;
export const updateArticleCategory = (id: number) => `${newsCategoriesPath}/${id}`;
